import { render } from "./SolutionDetail.vue?vue&type=template&id=58213d48&scoped=true"
import script from "./SolutionDetail.vue?vue&type=script&lang=js"
export * from "./SolutionDetail.vue?vue&type=script&lang=js"

import "./SolutionDetail.vue?vue&type=style&index=0&id=58213d48&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58213d48"],['__file',"src/views/qywx/ai/quotation/SolutionDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "58213d48"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('58213d48', __exports__)) {
    api.reload('58213d48', __exports__)
  }
  
  module.hot.accept("./SolutionDetail.vue?vue&type=template&id=58213d48&scoped=true", () => {
    api.rerender('58213d48', render)
  })

}


export default __exports__